import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-loader-component',
  templateUrl: './loader-component.component.html',
  styleUrls: ['./loader-component.component.scss']
})
export class LoaderComponentComponent implements OnInit {
  public isLoading:boolean = false;
  constructor(public loaderService: LoaderService) { 
  }
  ngOnInit() {  }
}